import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import "./Navbar.css";
import { FaInstagram, FaLinkedin, FaGithub } from "react-icons/fa";

function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    const previous = scrollY.getPrevious();
    // Show navbar at top of page or when scrolling up, hide when scrolling down
    if (latest < 80) {
      setHidden(false);
      setScrolled(false);
    } else {
      setScrolled(true);
      setHidden(latest > previous && latest > 150);
    }
  });

  const links = [
    { to: "/", label: "Home" },
    { to: "/energy", label: "Energy" },
    { to: "/robotics", label: "Robotics" },
    { to: "/arctic", label: "Arctic" },
    { to: "/experience", label: "Contact" },
  ];

  return (
    <motion.nav
      className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}
      animate={{ y: hidden ? "-110%" : "0%" }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
    >
      <div className="navbar-logo">
        <Link to="/">
          <img src="/E.svg" alt="Logo" width="48" height="48" />
        </Link>
      </div>
      <ul className="navbar-links">
        {links.map((link) => (
          <li key={link.to}>
            <Link to={link.to} className={location.pathname === link.to ? "active" : ""}>
              <span>{link.label}</span>
            </Link>
          </li>
        ))}
      </ul>
      <div className="navbar-social">
        <a href="https://instagram.com/edunca01" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
        <a href="https://linkedin.com/in/eugen-dunca" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedin />
        </a>
        <a href="https://github.com/edunca01" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
          <FaGithub />
        </a>
      </div>
    </motion.nav>
  );
}

export default Navbar;
